import { Modal, ModalContent } from "@heroui/react";
import { RentalContract } from "shared/types/rental-contracts";
import { IndexationCalculationPage } from "../IndexationCalculationPage";

interface IndexationCalculationModalProps {
  isOpen: boolean;
  onClose: () => void;
  contract: RentalContract | null;
  /** Called after an indexation is applied so the overview can drop the row. */
  onApplied?: (contractId: number) => void;
}

/**
 * Renders the full indexation calculation flow inside a modal on the indexaties
 * overview, instead of opening it in a new browser tab. The calculation view is
 * the same component used by the standalone route (`IndexationCalculationPage`),
 * rendered in its `embedded` layout.
 */
export const IndexationCalculationModal = ({
  isOpen,
  onClose,
  contract,
  onApplied,
}: IndexationCalculationModalProps) => {
  if (!isOpen || !contract) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="full"
      scrollBehavior="inside"
      classNames={{
        base: "max-h-[95vh] m-2",
        wrapper: "items-center",
      }}
    >
      <ModalContent className="bg-white">
        <IndexationCalculationPage
          embedded
          contractId={contract.id}
          contract={contract}
          onClose={onClose}
          onApplied={onApplied}
        />
      </ModalContent>
    </Modal>
  );
};
